var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoRequestPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "22px",
    viewBox: "0 0 34 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-833.000000, -1052.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(833.000000, 1052.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(0.000000, 1.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13-Copy-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,5.31000553 C5.41741656,3.71735986 2.88751618,3.85824359 1.91029885,5.73265674 C0.93308153,7.60706989 2.07663948,8.91845767 5.3409727,9.66682008 C8.67043368,10.7256063 9.67052397,12.1174477 8.34124357,13.8423442 C7.01196316,15.5672408 4.39821531,15.6636412 0.5,14.1315456",
    id: "Path-88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58404541,0.395507812 L5.58404541,19.296875",
    id: "Path-89"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14,17.9826194 C15.5621001,16.083271 16.5,13.6511646 16.5,11 C16.5,8.34883535 15.5621001,5.91672897 14,4.01738062 C16.0174454,1.5643805 19.0760324,0 22.5,0 C28.5751322,0 33.5,4.92486775 33.5,11 C33.5,17.0751322 28.5751322,22 22.5,22 C19.0760324,22 16.0174454,20.4356195 14,17.9826194 Z M24.3328304,13.4933881 L28.8852186,8.91421356 L27.471005,7.5 L22.9248477,12.072907 L20.4142136,9.53998647 L19,10.9542 L22.9321428,14.9212476 L24.3463563,13.507034 L24.3328304,13.4933881 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRequestPayment);
export default __webpack_public_path__ + "static/media/ico_request-payment.d216fc6eece22c0d91d53dd591bc0f69.svg";
export { ForwardRef as ReactComponent };